import { useEffect, useRef, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useFormDisable } from './form'
import { FormNewLabel } from './form-label'
import { IconCalender, IconClose } from '../icon/icon'
import datepicker from 'js-datepicker'

export const FormNewDateSelect = ({ name, label, required, disabled }) => {
  const { register, watch, setValue } = useFormContext()

  const ref = useRef()
  const [picker, updatePicker] = useState()
  const [isShowing, updateIsShowing] = useState(false)

  const value = watch(name)

  useEffect(
    () => {
      if (picker) {
        if (value) {
          const date = new Date(value)
          picker.setDate(date)
        } else {
          picker.setDate(null)
        }
      }
    },
    [picker, value]
  )

  const formDisabled = useFormDisable()

  useEffect(() => {
    if (!ref.current) {
      return
    }

    let picker = datepicker(ref.current, {
      showAllDates: true,
      onSelect: (_, date) => {
        setValue(name, date, { shouldDirty: true })
      },
      onShow: () => updateIsShowing(true),
      onHide: () => updateIsShowing(false)
    })

    updatePicker(picker)

    return () => {
      picker.remove()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCalendar = e => {
    e.stopPropagation()
    if (!formDisabled) {
      if (picker) {
        if (isShowing) picker.hide()
        else picker.show()
      }
    }
  }

  const handleClear = () => {
    if (!formDisabled) {
      setValue(name, null, { shouldDirty: true })
    }
  }

  return (
    <FormNewLabel name={name} label={label} required={required}>
      <input type="hidden" {...register(name, { required })} />
      <div className="input-group">
        <span className="input-group-text" onClick={handleCalendar}>
          <IconCalender />
        </span>
        <input className="form-control" ref={ref} readOnly disabled={formDisabled || disabled} />
        <span className="input-group-text" onClick={handleClear}>
          <IconClose />
        </span>
      </div>
    </FormNewLabel>
  )
}
